import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=04e402be&"
import script from "./Rank.vue?vue&type=script&lang=js&"
export * from "./Rank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e402be')) {
      api.createRecord('04e402be', component.options)
    } else {
      api.reload('04e402be', component.options)
    }
    module.hot.accept("./Rank.vue?vue&type=template&id=04e402be&", function () {
      api.rerender('04e402be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/Rank.vue"
export default component.exports